import { urlImg } from "../config";

const DEFAULT_TIME_ZONE = "-04:00"

const MIN_LIST = [
	{
		value: 0,
		name: "No aplica"
	},
	{
		value: 15 * 60 * 1000,
		name: "Durante 15 minutos"
	},
	{
		value: 30 * 60 * 1000,
		name: "Durante 30 minutos"
	},
	{
		value: 45 * 60 * 1000,
		name: "Durante 45 minutos"
	},
	{
		value: 60 * 60 * 1000,
		name: "Durante 1 hora"
	},
	{
		value: 120 * 60 * 1000,
		name: "Durante 2 horas"
	},
]

const HOURS_LIST = [
	{
		value: '00:00',
		name: '12:00 AM',
	},
	{
		value: '00:30',
		name: '12:30 AM',
	},
	{
		value: '01:00',
		name: '1:00 AM',
	},
	{
		value: '01:30',
		name: '1:30 AM',
	},
	{
		value: '02:00',
		name: '2:00 AM',
	},
	{
		value: '02:30',
		name: '2:30 AM',
	},
	{
		value: '03:00',
		name: '3:00 AM',
	},
	{
		value: '03:30',
		name: '3:30 AM',
	},
	{
		value: '04:00',
		name: '4:00 AM',
	},
	{
		value: '04:30',
		name: '4:30 AM',
	},
	{
		value: '05:00',
		name: '5:00 AM',
	},
	{
		value: '05:30',
		name: '5:30 AM',
	},
	{
		value: '06:00',
		name: '6:00 AM',
	},
	{
		value: '06:30',
		name: '6:30 AM',
	},
	{
		value: '07:00',
		name: '7:00 AM',
	},
	{
		value: '07:30',
		name: '7:30 AM',
	},
	{
		value: '08:00',
		name: '8:00 AM',
	},
	{
		value: '08:30',
		name: '8:30 AM',
	},
	{
		value: '09:00',
		name: '9:00 AM',
	},
	{
		value: '09:30',
		name: '9:30 AM',
	},
	{
		value: '10:00',
		name: '10:00 AM',
	},
	{
		value: '10:30',
		name: '10:30 AM',
	},
	{
		value: '11:00',
		name: '11:00 AM',
	},
	{
		value: '11:30',
		name: '11:30 AM',
	},
	{
		value: '12:00',
		name: '12:00 PM',
	},
	{
		value: '12:30',
		name: '12:30 PM',
	},
	{
		value: '13:00',
		name: '1:00 PM',
	},
	{
		value: '13:30',
		name: '1:30 PM',
	},
	{
		value: '14:00',
		name: '2:00 PM',
	},
	{
		value: '14:30',
		name: '2:30 PM',
	},
	{
		value: '15:00',
		name: '3:00 PM',
	},
	{
		value: '15:30',
		name: '3:30 PM',
	},
	{
		value: '16:00',
		name: '4:00 PM',
	},
	{
		value: '16:30',
		name: '4:30 PM',
	},
	{
		value: '17:00',
		name: '5:00 PM',
	},
	{
		value: '17:30',
		name: '5:30 PM',
	},
	{
		value: '18:00',
		name: '6:00 PM',
	},
	{
		value: '18:30',
		name: '6:30 PM',
	},
	{
		value: '19:00',
		name: '7:00 PM',
	},
	{
		value: '19:30',
		name: '7:30 PM',
	},
	{
		value: '20:00',
		name: '8:00 PM',
	},
	{
		value: '20:30',
		name: '8:30 PM',
	},
	{
		value: '21:00',
		name: '9:00 PM',
	},
	{
		value: '21:30',
		name: '9:30 PM',
	},
	{
		value: '22:00',
		name: '10:00 PM',
	},
	{
		value: '22:30',
		name: '10:30 PM',
	},
	{
		value: '23:00',
		name: '11:00 PM',
	},
	{
		value: '23:30',
		name: '11:30 PM',
	}
];

const TIMEZONES = [
	{
		value:'-12:00',
		name:'-12:00',
	},
	{
		value:'-11:30',
		name:'-11:30',
	},
	{
		value:'-11:00',
		name:'-11:00',
	},
	{
		value:'-10:30',
		name:'-10:30',
	},
	{
		value:'-10:00',
		name:'-10:00',
	},
	{
		value:'-09:30',
		name:'-09:30',
	},
	{
		value:'-09:00',
		name:'-09:00',
	},
	{
		value:'-08:30',
		name:'-08:30',
	},
	{
		value:'-08:00',
		name:'-08:00',
	},
	{
		value:'-07:30',
		name:'-07:30',
	},
	{
		value:'-07:00',
		name:'-07:00',
	},
	{
		value:'-06:30',
		name:'-06:30',
	},
	{
		value:'-06:00',
		name:'-06:00',
	},
	{
		value:'-05:30',
		name:'-05:30',
	},
	{
		value:'-05:00',
		name:'-05:00',
	},
	{
		value:'-04:30',
		name:'-04:30',
	},
	{
		value:'-04:00',
		name:'-04:00',
	},
	{
		value:'-03:30',
		name:'-03:30',
	},
	{
		value:'-03:00',
		name:'-03:00',
	},
	{
		value:'-02:30',
		name:'-02:30',
	},
	{
		value:'-02:00',
		name:'-02:00',
	},
	{
		value:'-01:30',
		name:'-01:30',
	},
	{
		value:'-01:00',
		name:'-01:00',
	},
	{
		value:'+00:00',
		name:'+00:00',
	},
	{
		value:'+00:30',
		name:'+00:30',
	},
	{
		value:'+01:00',
		name:'+01:00',
	},
	{
		value:'+01:30',
		name:'+01:30',
	},
	{
		value:'+02:00',
		name:'+02:00',
	},
	{
		value:'+02:30',
		name:'+02:30',
	},
	{
		value:'+03:00',
		name:'+03:00',
	},
	{
		value:'+03:30',
		name:'+03:30',
	},
	{
		value:'+04:00',
		name:'+04:00',
	},
	{
		value:'+04:30',
		name:'+04:30',
	},
	{
		value:'+05:00',
		name:'+05:00',
	},
	{
		value:'+05:30',
		name:'+05:30',
	},
	{
		value:'+06:00',
		name:'+06:00',
	},
	{
		value:'+06:30',
		name:'+06:30',
	},
	{
		value:'+07:00',
		name:'+07:00',
	},
	{
		value:'+07:30',
		name:'+07:30',
	},
	{
		value:'+08:00',
		name:'+08:00',
	},
	{
		value:'+08:30',
		name:'+08:30',
	},
	{
		value:'+09:00',
		name:'+09:00',
	},
	{
		value:'+09:30',
		name:'+09:30',
	},
	{
		value:'+10:00',
		name:'+10:00',
	},
	{
		value:'+10:30',
		name:'+10:30',
	},
	{
		value:'+11:00',
		name:'+11:00',
	},
	{
		value:'+11:30',
		name:'+11:30',
	},
	{
		value:'+12:00',
		name:'+12:00',
	},
	{
		value:'+12:30',
		name:'+12:30',
	},
	{
		value:'+13:00',
		name:'+13:00',
	},
	{
		value:'+13:30',
		name:'+13:30',
	},
	{
		value:'+14:00',
		name:'+14:00',
	}
];

const GEO_DECIMAL_PLACES = 1000000;

const LANGUAGES = [
	{"value": 'es', "name": `Español`},
	{"value": 'en', "name": `English`},
]

const CITIES = [
	{"value": 10, "name": 'Caracas'},
	{"value": 3, "name": 'Cumana'}
]

const MIN_RAINTING_COUNT_TO_SHOW = 1;

const MANDATORY_NUMBER_REGEX="^[0-9]+^";
const NUMBER_REGEX="^[0-9]*^";

const MANDATORY_TXT_REGEX ="^.+^";
const TXT_REGEX ="^.*^";
const TXT_REGEX_MIN4 ="^(.){4,}^";
const MANDATORY_EMAIL_REGEX ="^[a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}\\@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+^";
const EMAIL_REGEX ="^([a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}\\@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+)?^";

const TXT_DATE ="^([0-2][0-9]|(3)[0-1])(\\\/)(((0)[0-9])|((1)[0-2]))(\\\/)\\d{4}^";

const UNLIMITED_STOCK = -1;

const FLAG_ADMIN_CUSTOMIZABLE = 268435456;

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_ORDERS_PAGE_SIZE = 20;
const DEFAULT_PRODUCTS_PAGE_SIZE = 100;

const FLEET_CURRENCIES_ISO = [
	{
		value: "VES",
		label: "VES"
	}
]

const FLEET_BINDING_ATTRIBUTE = [
	{
		value: "providers:pos_serial",
		label: "providers:pos_serial"
	}
]

const BANCOS_VENEZUELA = [
	'100% Banco',
	'ABN AMRO Bank',
	'Bancamiga',
	'Banco Activo Banco Comercial',
	'Banco Agricola',
	'Banco Bicentenario',
	'Banco Caroni Banco Universal',
	'Banco De Desarrollo Del Microempresario',
	'Banco de Venezuela',
	'Banco Del Caribe',
	'Banco Del Pueblo Soberano',
	'Banco Del Tesoro',
	'Banco Espirito Santo',
	'Banco Exterior',
	'Banco Industrual De Venezuela',
	'Banco internacional De Desarrollo',
	'Banco Mercantil',
	'Banco Nacional De Credito',
	'Banco Occidental De Descuento',
	'Banco Plaza',
	'Banco Provincial BBVA',
	'Banco Venezolano De Credito',
	'Bancrecer Banco De Desarrollo',
	'Banesco Banco Universal',
	'BANFANB',
	'Bangente',
	'Banplus Banco Comercial',
	'Citibank',
	'Corp Banca',
	'DELSUR Banco Universal',
	'BancoFondoComun',
	'Instituto Municipal De Credito Popular',
	'Mi Banco, Banco de desarrollo',
	'Sofitasa'
]

const PM_VENEZUELA = [
	{
	  "value": "0102",
	  "name": "0102 - Banco de Venezuela"
	},
	{
	  "value": "0104",
	  "name": "0104 - Venezolano de Crédito"
	},
	{
	  "value": "0105",
	  "name": "0105 - Banco Mercantil"
	},
	{
	  "value": "0108",
	  "name": "0108 - Banco Provincial"
	},
	{
	  "value": "0114",
	  "name": "0114 - Bancaribe"
	},
	{
	  "value": "0115",
	  "name": "0115 - Banco Exterior"
	},
	{
	  "value": "0116",
	  "name": "0116 - Banco Occidental de Descuento"
	},
	{
	  "value": "0128",
	  "name": "0128 - Banco Caroní"
	},
	{
	  "value": "0134",
	  "name": "0134 - Banesco"
	},
	{
	  "value": "0137",
	  "name": "0137 - Banco Sofitasa"
	},
	{
	  "value": "0138",
	  "name": "0138 - Banco Plaza"
	},
	{
	  "value": "0146",
	  "name": "0146 - Banco de la Gente Emprendedora"
	},
	{
	  "value": "0151",
	  "name": "0151 - BFC Banco Fondo Común"
	},
	{
	  "value": "0156",
	  "name": "0156 - 100% Banco"
	},
	{
	  "value": "0157",
	  "name": "0157 - DelSur Banco"
	},
	{
	  "value": "0163",
	  "name": "0163 - Banco del Tesoro"
	},
	{
	  "value": "0166",
	  "name": "0166 - Banco Agrícola de Venezuela"
	},
	{
	  "value": "0168",
	  "name": "0168 - Bancrecer"
	},
	{
	  "value": "0169",
	  "name": "0169 - Mi Banco"
	},
	{
	  "value": "0171",
	  "name": "0171 - Banco Activo"
	},
	{
	  "value": "0172",
	  "name": "0172 - Bancamica"
	},
	{
	  "value": "0173",
	  "name": "0173 - Banco Internacional de Desarrollo"
	},
	{
	  "value": "0174",
	  "name": "0174 - Banplus"
	},
	{
	  "value": "0175",
	  "name": "0175 - Banco Bicentenario"
	},
	{
	  "value": "0176",
	  "name": "0176 - Novos Banco"
	},
	{
	  "value": "0177",
	  "name": "0177 - Banco de la Fuerza Armana Nacional Bolivariana"
	},
	{
	  "value": "0190",
	  "name": "0190 - Citibank"
	},
	{
	  "value": "0191",
	  "name": "0191 - Banco Nacional de Crédito"
	}
];

const DNI = [
	{
		"value": "V",
		"name": "V"
	},
	{
		"value": "E",
		"name": "E"
	},
	{
		"value": "J",
		"name": "J (R.I.F)"
	},
	{
		"value": "G",
		"name": "G"
	},
]

// Tipo de acceso por numero para facilitar comparaciones
const BRANCH_ACCESS = 1;
const BRANCH_GROUPS_ACCESS = 2;
const COMPANY_ACCESS = 3;

const CARACAS_GEO_POSTITION = [10.48801, -66.87919];

const ACCOUNT_TYPES = {
	client: 0,
	provider: 15,
	sellerAdmin: 48,
	lowAdmin: 112,
	highAdmin: 119,
	ownerAdmin: 127,
	superAdmin: 255
}

const BRANCH_PROPERTY_TYPES = {
	numeric: 512,
	list: 256,
	text: 1024
}

const PHONE_PREFIX = [
	{
		value:'58',
		name:'+58',
	},
]

const PHONE_COMPANY_PREFIX = [
	{
		value: "412",
		name: "0412"
	},
	{
		value: "422",
		name: "0422"
	},
	{
		value: "414",
		name: "0414"
	},
	{
		value: "424",
		name: "0424"
	},
	{
		value: "416",
		name: "0416"
	},
	{
		value: "426",
		name: "0426"
	}
]

const PM_PREFIX = [
	{
		"value": "0412",
		"name": "0412"
	},
	{
		"value": "0414",
		"name": "0414"
	},
	{
		"value": "0416",
		"name": "0416"
	},
	{
		"value": "0422",
		"name": "0422"
	},
	{
		"value": "0424",
		"name": "0424"
	},
	{
		"value": "0426",
		"name": "0426"
	}
]

// REPORTES

export const REPORT_ADMIN = "report-admin";
export const REPORT_OUT_OF_STOCK = "report-oos";
export const REPORT_ZUPPER_SELLS = "report-zs";
export const REPORT_BANCAMIGA = "report-bancamiga";
export const REPORT_BALANCE_MODIFIERS = "report-bmod";
export const REPORT_CITY_MOVEMENTS = "report-citym";
export const REPORT_CITY_SUMMARY = "report-citys";
export const REPORT_BRANCH_DETAILS = "report-bd";
export const REPORT_BRANCH_GROUP_SALE_DETAILS = "report-bgsd";
export const REPORT_BRANCH_PENDING_FEES = "report-bpf";
export const REPORT_BRANCH_PAID_INVOICES = "report-bpi";
export const REPORT_BRANCH_PAID_INVOICES_ALT = "report-bpialt";
export const REPORT_PAID_ORDERS_TO_BRANCH = "report-potb";
export const REPORT_PENDING_FEES_TO_RIDERS = "report-pftr";
export const REPORT_RIDERS_PAID_INVOICES = "report-rpi";
export const REPORT_RIDERS_ONLINE = "report-ro";
export const REPORT_RIDERS_MOVEMENTS = "report-rm";
export const REPORT_RIDERS_STATUS = "report-rs";
export const REPORT_ACCESS = "report-access";
export const REPORT_USERS = "report-users";
export const REPORT_USERS_EMAIL = "report-ue";
export const REPORT_CLIENTS_WITH_BALANCE = "report-cwb";
export const REPORT_CLIENTS_MOVEMENTS = "report-cm";
export const REPORT_CLIENT_PAID_INVOICES = "report-cpi";
export const REPORT_USER_LOGINS = "report-ul";
export const REPORT_COMPANY_SALES = "report-cs";
export const REPORT_COMPANY_PAYMENT_DETAILS = "report-cpd";
export const REPORT_RECENT_USERS = "report-ru";
export const REPORT_GENERAL_ORDERS = "report-go";
export const REPORT_COMPANY_FINANCE_ORDERS = "report-cfo";
export const REPORT_COMPANY_ORDERS_REVENUE = "report-core";
export const REPORT_ORDER_RATINGS = "report-or";
export const REPORT_BRANCH_ORDERS = "report-bo";
export const REPORT_RIDERS_EARNINGS = "report-rre";
export const REPORT_RIDER_EARNINGS = "report-re";
export const REPORT_GENERAL_OPERATIONS_OF_RIDERS = "report-goorr";
export const REPORT_GENERAL_OPERATIONS_OF_RIDER = "report-goor";
export const REPORT_PRODUCTS_PURCHASED_BY_USERS = "report-ppbu";
export const REPORT_PRODUCTS_SOLD_BY_BRANCH = "report-psbb";
export const REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH = "report-psbuob";
export const REPORT_TOTAL_PRODUCTS_SOLD = "report-tps";
export const REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER = "report-tppbu";
export const REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH = "report-tpsbb";
export const REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH = "report-tppbuib";
export const REPORT_ORDERS_BY_USER = "report-obu";
export const REPORT_CLIENT_PENDING_INVOICES = "report-cpia";
export const REPORT_BRANCH_LIST = "report-bl";
export const REPORT_BRANCH_REPORTS = "report-br";
export const REPORT_COUPONS = "report-coupons";
export const REPORT_COUPON_INVESTMENTS = "report-ci";
export const REPORT_AVAILABLE_COUPONS = "report-ac";
export const REPORT_USED_COUPONS = "report-uc";
export const REPORT_BRANCH_PROMOTION = "report-bp";
export const REPORT_BRANCH_MOVEMENTS = "report-bm";
export const REPORT_PROVIDER_FEES = "report-pf";


const REPORTS_LIST = [
	{
		type: "company",
		reports: [
			{
				name: 'Administradores',
				value: REPORT_ADMIN,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ventas de Zupper',
				value: REPORT_ZUPPER_SELLS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: true,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Reporte Bancamiga',
				value: REPORT_BANCAMIGA,
				permissions: {
					type: COMPANY_ACCESS,
					withFile: true,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Uso de Zupper Créditos',
				value: REPORT_BALANCE_MODIFIERS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Movimientos de la ciudad',
				value: REPORT_CITY_MOVEMENTS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: true,
					forceCity: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Finanzas de la ciudad',
				value: REPORT_CITY_SUMMARY,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.highAdmin,
					withDates: true,
					forceCity: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Reporte de accesos',
				value: REPORT_ACCESS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de comercio',
				value: REPORT_BRANCH_DETAILS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Facturas pendientes de comercios',
				value: REPORT_BRANCH_PENDING_FEES,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Facturas pagadas a comercio',
				value: REPORT_BRANCH_PAID_INVOICES,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Órdenes pagadas a comercios',
				value: REPORT_PAID_ORDERS_TO_BRANCH,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ventas de Compañia',
				value: REPORT_COMPANY_SALES,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de pago de compañia',
				value: REPORT_COMPANY_PAYMENT_DETAILS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Órdenes generales',
				value: REPORT_GENERAL_ORDERS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Reporte ordenes generadas - Administración',
				value: REPORT_COMPANY_FINANCE_ORDERS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ingresos de órdenes generales',
				value: REPORT_COMPANY_ORDERS_REVENUE,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ratings de órdenes',
				value: REPORT_ORDER_RATINGS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: true,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Total general de productos vendidos',
				value: REPORT_TOTAL_PRODUCTS_SOLD,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Listado de comercios',
				value: REPORT_BRANCH_LIST,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Productos de comercio',
				value: REPORT_BRANCH_REPORTS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: false, // Dependera de si esta activa no una branch id
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: true,
					appendingQueryString: false
				}
			},
			{
				name: 'Cupones',
				value: REPORT_COUPONS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Inversión por cupón',
				value: REPORT_COUPON_INVESTMENTS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: true,
					dependsOnBranch: false,
					withBranchGroups: true,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Cupones disponibles',
				value: REPORT_AVAILABLE_COUPONS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Cupones usados',
				value: REPORT_USED_COUPONS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
		]
	},
	{
		type: "branches",
		reports: [
			{
				name: 'Productos agotados',
				value: REPORT_OUT_OF_STOCK,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: true,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de ventas de grupo de comercio',
				value: REPORT_BRANCH_GROUP_SALE_DETAILS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: true,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Órdenes de comercio',
				value: REPORT_BRANCH_ORDERS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Facturas pagadas a comercio',
				value: REPORT_BRANCH_PAID_INVOICES_ALT,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de productos vendidos por comercio',
				value: REPORT_PRODUCTS_SOLD_BY_BRANCH,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Total de productos vendidos por comercio',
				value: REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Promoción de comercio',
				value: REPORT_BRANCH_PROMOTION,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: true,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Movimientos de comercio',
				value: REPORT_BRANCH_MOVEMENTS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Envíos de comercio',
				value: REPORT_PROVIDER_FEES,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: false,
					withBranches: true,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: true,
					withBranchGroups: false,
					branchAsParameter: true,
					appendingQueryString: false
				}
			},
		]
	},
	{
		type: "providers",
		reports: [
			{
				name: 'Facturas pendientes de repartidores',
				value: REPORT_PENDING_FEES_TO_RIDERS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Facturas pagadas a repartidores',
				value: REPORT_RIDERS_PAID_INVOICES,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Repartidores online',
				value: REPORT_RIDERS_ONLINE,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Balance de repartidores',
				value: REPORT_RIDERS_MOVEMENTS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Estado de proveedores',
				value: REPORT_RIDERS_STATUS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					withTimezone: true,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ganancias de los Riders',
				value: REPORT_RIDERS_EARNINGS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Ganancias de un rider',
				value: REPORT_RIDER_EARNINGS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: true,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de operaciones generales de Riders',
				value: REPORT_GENERAL_OPERATIONS_OF_RIDERS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de operaciones de un Rider',
				value: REPORT_GENERAL_OPERATIONS_OF_RIDER,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: true,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
		]
	},
	{
		type: "clients",
		reports: [
			{
				name: 'Usuarios',
				value: REPORT_USERS,
				permissions: {
					type: BRANCH_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Correo electrónico de usuarios',
				value: REPORT_USERS_EMAIL,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Clientes con Saldo',
				value: REPORT_CLIENTS_WITH_BALANCE,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: false,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Movimientos de los clientes',
				value: REPORT_CLIENTS_MOVEMENTS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Reembolsos a clientes',
				value: REPORT_CLIENT_PAID_INVOICES,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Inicio de sesión de usuarios',
				value: REPORT_USER_LOGINS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: { count: 31, time: 'days' },
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Últimos usuarios registrados',
				value: REPORT_RECENT_USERS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: { count: 31, time: 'days' },
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de productos comprados por usuarios',
				value: REPORT_PRODUCTS_PURCHASED_BY_USERS,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: true,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Detalles de productos vendidos por un usuario en un comercio',
				value: REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: true,
					withClients: true,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: true,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Total de productos comprados por usuario en comercio',
				value: REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: true,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: true,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Total de productos comprados por usuario',
				value: REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: true,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: false,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Órdenes por usuario',
				value: REPORT_ORDERS_BY_USER,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
			{
				name: 'Facturas pendientes de clientes',
				value: REPORT_CLIENT_PENDING_INVOICES,
				permissions: {
					type: COMPANY_ACCESS,
					hierarchy: ACCOUNT_TYPES.lowAdmin,
					withDates: true,
					autoBranch: false,
					withClients: false,
					withBranches: false,
					maxDateRange: false,
					withProviders: false,
					activateModal: true,
					branchRequired: false,
					withCityFilter: false,
					withAllBranches: false,
					dependsOnBranch: false,
					withBranchGroups: false,
					branchAsParameter: false,
					appendingQueryString: false
				}
			},
		]
	},
];

const PERMISSIONS_LIST = [
	{
		name: "Asignar proveedores a la empresa",
		value: "can_assign_company_providers"
	},
	{
		name: "Gestionar textos de la plataforma",
		value: "can_manage_platform_texts"
	},
	{
		name: "Gestionar servicios",
		value: "can_manage_services"
	},
	{
		name: "Gestionar proveedores de servicios",
		value: "can_manage_service_suppliers"
	},
	{
		name: "Gestionar webhooks",
		value: "can_manage_webhooks"
	},
	{
		name: "Gestionar balance",
		value: "can_manage_balance"
	},
	{
		name: "Gestionar facturas generales",
		value: "can_manage_general_invoices"
	},
	{
		name: "Ver monedas de órdenes",
		value: "can_see_order_currencies"
	}
]

const ORDER_COUPON_REASONS = [
	{ name: "Comida en mal estado", value: "Comida en mal estado" },
	{ name: "Orden incompleta", value: "Orden incompleta" },
	{ name: "Helados derretidos", value: "Helados derretidos" },
	{ name: "Orden no entregada", value: "Orden no entregada" },
	{ name: "Producto errado", value: "Producto errado" },
	{ name: "Tiempo de espera excedido", value: "Tiempo de espera excedido" },
	{ name: "Comida fría", value: "Comida fría" },
	{ name: "Otros", value: "Otros" }
  ];

const WEBHOOKS_NAMES = [
	{
		name: "goods_import",
		value: "goods_import",
		description: "Envía peticiones para obtener y actualizar el Inventario de Productos"
	},
	{
		name: "order_status_report",
		value: "order_status_report",
		description: "Envía cambios de status de una orden"
	},
	{
		name: "payments_validation_zelle",
		value: "payments_validation_zelle",
		description: "Recibe validación automática de pagos por Zelle"
	},
	{
		name: "payments_validation_payco",
		value: "payments_validation_payco",
		description: "Deprecado"
	},
	{
		name: "payments_validation_sypago",
		value: "payments_validation_sypago",
		description: "Recibe validación automática de pagos de Bancamiga"
	},
	{
		name: "payments_report_stripe",
		value: "payments_report_stripe",
		description: "Recibe validación automática de pagos de Stripe"
	},
	{
		name: "payments_validation_reserve",
		value: "payments_validation_reserve",
		description: "Deprecado"
	},
	{
		name: "payments_validation_binance",
		value: "payments_validation_binance",
		description: "Recibe validación automática de pagos por Binance"
	},
	{
		name: "orders_handling",
		value: "orders_handling",
		description: "Recibe peticiones para cambiar status de una orden"
	},
	{
		name: "delivery_handling",
		value: "delivery_handling",
		description: " Recibe peticiones para cambiar status de un repartidor ApiPartner"
	},
	{
		name: "fleet_prices_ridery",
		value: "fleet_prices_ridery",
		description: "Deprecado"
	},
	{
		name: "fleet_prices_partner",
		value: "fleet_prices_partner",
		description: "Envía petición para obtener los precios de Envío de una Flota de ApiPartner"
	},
	{
		name: "order_creation_ridery",
		value: "order_creation_ridery",
		description: "Deprecado"
	},
	{
		name: "order_creation_partner",
		value: "order_creation_partner",
		description: "Envía petición para notificar que una orden fue creada"
	},
	{
		name: "shipment_creation_ridery",
		value: "shipment_creation_ridery",
		description: "Deprecado"
	},
	{
		name: "shipment_creation_partner",
		value: "shipment_creation_partner",
		description: "Envía petición para notificar que una orden requiere la asignación de un conductor de ApiPartner"
	},
	{
		name: "clients_register_ridery",
		value: "clients_register_ridery",
		description: "Deprecado"
	},
	{
		name: "clients_register_partner",
		value: "clients_register_partner",
		description: "Recibe peticiones para registrar a un comprador en la plataforma y otorga un token de acceso (ApiPartner)"
	},
	{
		name: "promos_sync",
		value: "promos_sync",
		description: "Envía petición para obtener y sincronizar las promociones de un comercio"
	},
	{
		name: "discounts_refresh",
		value: "discounts_refresh",
		description: "Envía petición para obtener y sincronizar los descuentos de un comercio"
	},
	{
		name: "sms_delivery",
		value: "sms_delivery",
		description: "Recibe petición que indica que un SMS fue entregado"
	}
];

const WEBHOOK_METHODS = [
	{
		value: "GET",
		name: "GET"
	},
	{
		value: "POST",
		name: "POST"
	},
	{
		value: "PATCH",
		name: "PATCH"
	},
	{
		value: "PUT",
		name: "PUT"
	},
	{
		value: "DELETE",
		name: "DELETE"
	}
];

const WEBHOOK_AUTH_TYPES = [
	{
		value: "none",
		name: "Ninguno"
	},
	{
		value: "basic",
		name: "Básico (Usuario y contraseña)"
	},
	{
		value: "token",
		name: "Token"
	},
	{
		value: "bearer",
		name: "Bearer (Token)"
	}
];

export const IMPORT_CONFIG_GOOD_ITEMS =[
	{
		value:'name',
		name:'Nombre',
	},
	{
		value:'sku',
		name:'Sku',
	},
	{
		value:'price',
		name:'Precio',
	},
	{
		value:'details',
		name:'Detalles',
	},
	
	{
		value:'branch_id',
		name:'Id de sucursal',
	},
	{
		value:'eta',
		name:'ETA',
	},
	{
		value:'list_order',
		name:'Orden de lista',
	},
	{
		value: 'sale_price',
		name: 'Precio de venta'
	},
	{
		value:'unit',
		name:'Unidad',
	},
	{
		value:'image_url',
		name:'Url de la imagen',
	},
	{
		value:'vertical_image_url',
		name:'Url de la imagen vertical',
	},
	{
		value:'category',
		name:'Categoria',
	},
	{
		value:'quantity',
		name:'Cantidad',
	},
	{
		value:'notes_enabled',
		name:'Notas habilitadas',
	},
	{
		value:'weight_per_unit',
		name:'Peso por unidad',
	},
	{
		value:'branch_code',
		name:'Codigo de sucursal',
	},
	
]
export const IMPORT_CONFIG_MAPPING_OPTIONS = [
	{
		value:'decimal',
		name:'Usa "," para separar miles y "." para separar decimales',
	},
	{
		value:'decimal_alt',
		name:'Usa "." para separar miles y "," para separar decimales',
	},
	{
		value:'to_prc',
		name:'Convertir % 0-100 a 0-1',
	},
	{
		value:'ucwords',
		name:'Tipo título',
	},
	{
		value:'to_e2',
		name:'Convertir a e2',
	},
	{
		value:'to_e6',
		name:'Convertir a e6',
	},
	{
		value: 'pluck',
		name: 'Pluck'
	}
]

export const CSV_SETTINGS = [
	{ name: "delimiter", value: "delimiter" },
	{ name: "enclosure", value: "enclosure" },
	{ name: "line_ending", value: "line_ending" },
	{ name: "use_bom", value: "use_bom" },
	{ name: "include_separator_line", value: "include_separator_line" },
	{ name: "excel_compatibility", value: "excel_compatibility" },
	{ name: "escape_character", value: "escape_character" },
	{ name: "contiguous", value: "contiguous" },
	{ name: "input_encoding", value: "input_encoding" },
	{ name: "output_encoding", value: "output_encoding" }
  ];
  
  

const PAYMENT_IS_WAITING_CONFIRMATION = 5;
const PAYMENT_IS_CANCELLED_BY_CLIENT = 10;
const PAYMENT_IS_CANCELLED_AS_DUPLICATED = 13;
const PAYMENT_IS_CANCELLED_AS_INVALID = 14
const PAYMENT_IS_ACCEPTED = 15

const MASK_AGENT = 0xfff0;
const AGENT_MANUAL = 0x0010;
const AGENT_PAYPAL = 0x0020;
const AGENT_STRIPE = 0x0040;
const AGENT_INSTAPAGO = 0x0080;
const AGENT_ZELLE = 0x0100;
const AGENT_POST_PAYMENT = 0x0200;

const DAYS_LIST = [
  {
    name: 'sunday',
    value: 0,
  },
  {
    name: 'monday',
    value: 1,
  },
  {
    name: 'tuesday',
    value: 2,
  },
  {
    name: 'wednesday',
    value: 3,
  },
  {
    name: 'thursday',
    value: 4,
  },
  {
    name: 'friday',
    value: 5,
  },
  {
    name: 'saturday',
    value: 6,
  },
];

export const DEFAULT_AVATAR_URL = `${urlImg}avatar.png`;
export const DEFAULT_PRODUCT_URL = `${urlImg}ping.png`;

export {
	MASK_AGENT,
	AGENT_MANUAL,
	AGENT_PAYPAL,
	AGENT_STRIPE,
	AGENT_INSTAPAGO,
	AGENT_ZELLE,
	AGENT_POST_PAYMENT,
	PAYMENT_IS_WAITING_CONFIRMATION,
	PAYMENT_IS_CANCELLED_BY_CLIENT,
	PAYMENT_IS_CANCELLED_AS_DUPLICATED,
	PAYMENT_IS_CANCELLED_AS_INVALID,
	PAYMENT_IS_ACCEPTED,
	BRANCH_ACCESS,
	BRANCH_PROPERTY_TYPES,
	DEFAULT_PAGE_SIZE,
	DEFAULT_ORDERS_PAGE_SIZE,
	DEFAULT_PRODUCTS_PAGE_SIZE,
	CARACAS_GEO_POSTITION,
	BRANCH_GROUPS_ACCESS,
	COMPANY_ACCESS,
	TXT_REGEX_MIN4,
	TXT_DATE,
	DEFAULT_TIME_ZONE,
	EMAIL_REGEX,
	MIN_LIST,
	HOURS_LIST,
	GEO_DECIMAL_PLACES,
	LANGUAGES,
	CITIES,
	MIN_RAINTING_COUNT_TO_SHOW,
	NUMBER_REGEX,
	TXT_REGEX,
	MANDATORY_NUMBER_REGEX,
	MANDATORY_TXT_REGEX,
	UNLIMITED_STOCK,
	FLAG_ADMIN_CUSTOMIZABLE,
	MANDATORY_EMAIL_REGEX,
	BANCOS_VENEZUELA,
	PM_VENEZUELA,
	DNI,
	TIMEZONES,
	ACCOUNT_TYPES,
	PHONE_PREFIX,
	PHONE_COMPANY_PREFIX,
	PM_PREFIX,
	REPORTS_LIST,
	FLEET_CURRENCIES_ISO,
	FLEET_BINDING_ATTRIBUTE,
	PERMISSIONS_LIST,
	ORDER_COUPON_REASONS,
	DAYS_LIST,
	WEBHOOKS_NAMES,
	WEBHOOK_METHODS,
	WEBHOOK_AUTH_TYPES
}



// WEBPACK FOOTER //
// ./src/constants/general.js